import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Box, Modal, Text } from '@mantine/core';

import { BulkUploadType } from '../constants/mediaConfig';
import { contentTypes } from '../types';

type PreviewType = Extract<BulkUploadType, 'photo' | 'video' | 'audio'>;

type MediaPreviewModalProps = {
  mediaType: PreviewType;
  src: string;
  title?: string;
};

export const isPreviewableMedia = (
  type: BulkUploadType | contentTypes.ContentType
): type is PreviewType => type === 'photo' || type === 'video' || type === 'audio';

export const MediaPreviewModal = NiceModal.create(
  ({ mediaType, src, title }: MediaPreviewModalProps) => {
    const modal = useModal();

    return (
      <Modal
        centered
        size={mediaType === 'photo' ? 'lg' : 'md'}
        opened={modal.visible}
        onClose={() => modal.remove()}
        title={title ?? 'Просмотр'}
        overlayProps={{ opacity: 0.55, blur: 2 }}
        padding="md"
      >
        <Box>
          {mediaType === 'photo' && (
            <img
              src={src}
              alt={title ?? ''}
              style={{
                display: 'block',
                maxWidth: '100%',
                maxHeight: '70vh',
                margin: '0 auto',
                borderRadius: 8,
                objectFit: 'contain',
              }}
            />
          )}
          {mediaType === 'video' && (
            <video
              src={src}
              controls
              autoPlay
              style={{
                display: 'block',
                width: '100%',
                maxHeight: '70vh',
                borderRadius: 8,
                backgroundColor: '#000',
              }}
            />
          )}
          {mediaType === 'audio' && (
            <Box py="md">
              {title && (
                <Text size="sm" c="dimmed" mb="md" ta="center">
                  {title}
                </Text>
              )}
              <audio src={src} controls autoPlay style={{ width: '100%' }} />
            </Box>
          )}
        </Box>
      </Modal>
    );
  }
);
